import { runBasePreload } from '../generalPreload';

const runPreload = (data, dispatchChangeLoadingState) => {
  runBasePreload(data, dispatchChangeLoadingState);
};

export default runPreload;
